import { useCallback } from "react";
import { useAppDispatch } from "./hooks";
import { sendMemberEventAsync } from "../features/admin/adminSlice";

type NavigateType =
  | "Person"
  | "Phone"
  | "Property"
  | "Social"
  | "Vehicle"
  | "Neighborhood";

const useTrackNavigateToSection = (searchType: NavigateType) => {
  const dispatch = useAppDispatch();

  return useCallback(
    (sectionLabel: string) => {
      dispatch(
        sendMemberEventAsync({
          EventCategory: "Click",
          EventAction: "Navigate to Section",
          MetaData: JSON.stringify({
            [searchType]: sectionLabel,
          }),
        }),
      );
    },
    [dispatch, searchType],
  );
};

export default useTrackNavigateToSection;
